import { BaseEncoder } from "./BaseEncoder";
import { BaseObjectEncoder } from "./BaseObjectEncoder";
import { DefaultBaseObjectEncoderImpl } from "./DefaultBaseObjectEncoderImpl";

import { CurrencyPairImpl } from "../model/impl/CurrencyPairImpl";
import { Encodable } from "../model/Encodable";

import * as CubiqTS from "../index";

export class CurrencyPairImplEncoder implements BaseEncoder {
  public baseEncoder: BaseObjectEncoder = new DefaultBaseObjectEncoderImpl();

  private static _instance;

  private constructor() {}

  public static get Instance() {
    // Do you need arguments? Make it a regular method instead.
    return this._instance || (this._instance = new this());
  }

  public encode(encodable: CurrencyPairImpl, streamout: CubiqTS.ByteBuffer): void {
    this.baseEncoder.encode(encodable, streamout);

    this.baseEncoder.writeStartEncoding(streamout);

    /*Object encoding*/
    if (encodable.base != null) {
      this.baseEncoder.writeStartFid(1, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(1),
        false,
        encodable.base,
        streamout,
      );
      this.baseEncoder.writeEndFid(1, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdEnabledFg != null) {
      this.baseEncoder.writeStartFid(3, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(3),
        false,
        encodable.fwdEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(3, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdInvertDecimalsQty != null) {
      this.baseEncoder.writeStartFid(4, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(4),
        false,
        encodable.fwdInvertDecimalsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(4, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdRateDecimalsQty != null) {
      this.baseEncoder.writeStartFid(6, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(6),
        false,
        encodable.fwdRateDecimalsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(6, streamout);
    }
    /*Object encoding*/
    if (encodable.nonBase != null) {
      this.baseEncoder.writeStartFid(7, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(7),
        false,
        encodable.nonBase,
        streamout,
      );
      this.baseEncoder.writeEndFid(7, streamout);
    }
    /*Object encoding*/
    if (encodable.orderTempHotValue != null) {
      this.baseEncoder.writeStartFid(8, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(8),
        false,
        encodable.orderTempHotValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(8, streamout);
    }
    /*Object encoding*/
    if (encodable.orderTempWarmValue != null) {
      this.baseEncoder.writeStartFid(9, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(9),
        false,
        encodable.orderTempWarmValue,
        streamout,
      );
      this.baseEncoder.writeEndFid(9, streamout);
    }
    /*Object encoding*/
    if (encodable.pipsQty != null) {
      this.baseEncoder.writeStartFid(10, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(10),
        false,
        encodable.pipsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(10, streamout);
    }
    /*Object encoding*/
    if (encodable.rateStaleTimeInSecs != null) {
      this.baseEncoder.writeStartFid(11, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(11),
        false,
        encodable.rateStaleTimeInSecs,
        streamout,
      );
      this.baseEncoder.writeEndFid(11, streamout);
    }
    /*Object encoding*/
    if (encodable.spotEnabledFg != null) {
      this.baseEncoder.writeStartFid(12, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(12),
        false,
        encodable.spotEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(12, streamout);
    }
    /*Object encoding*/
    if (encodable.spotInvertDecimalsQty != null) {
      this.baseEncoder.writeStartFid(13, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(13),
        false,
        encodable.spotInvertDecimalsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(13, streamout);
    }
    /*Object encoding*/
    if (encodable.stamp != null) {
      this.baseEncoder.writeStartFid(15, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(15),
        false,
        encodable.stamp,
        streamout,
      );
      this.baseEncoder.writeEndFid(15, streamout);
    }
    /*Object encoding*/
    if (encodable.ndfEnabledFg != null) {
      this.baseEncoder.writeStartFid(16, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(16),
        false,
        encodable.ndfEnabledFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(16, streamout);
    }
    /*Object encoding*/
    if (encodable.rateDecimalsQty != null) {
      this.baseEncoder.writeStartFid(17, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(17),
        false,
        encodable.rateDecimalsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(17, streamout);
    }
    /*Object encoding*/
    if (encodable.spotDaysQty != null) {
      this.baseEncoder.writeStartFid(18, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(18),
        false,
        encodable.spotDaysQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(18, streamout);
    }
    /*Object encoding*/
    if (encodable.fixingDaysQty != null) {
      this.baseEncoder.writeStartFid(19, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(19),
        false,
        encodable.fixingDaysQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(19, streamout);
    }
    /*Object encoding*/
    if (encodable.allowSpotFg != null) {
      this.baseEncoder.writeStartFid(20, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(20),
        false,
        encodable.allowSpotFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(20, streamout);
    }
    /*Object encoding*/
    if (encodable.allowFwdSpotTriggerFg != null) {
      this.baseEncoder.writeStartFid(21, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(21),
        false,
        encodable.allowFwdSpotTriggerFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(21, streamout);
    }
    /*Object encoding*/
    if (encodable.allowFwdFwdTriggerFg != null) {
      this.baseEncoder.writeStartFid(22, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(22),
        false,
        encodable.allowFwdFwdTriggerFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(22, streamout);
    }
    /*Object encoding*/
    if (encodable.allowNdfSpotTriggerFg != null) {
      this.baseEncoder.writeStartFid(25, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(25),
        false,
        encodable.allowNdfSpotTriggerFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(25, streamout);
    }
    /*Object encoding*/
    if (encodable.allowNdfFwdTriggerFg != null) {
      this.baseEncoder.writeStartFid(26, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(26),
        false,
        encodable.allowNdfFwdTriggerFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(26, streamout);
    }
    /*Object encoding*/
    if (encodable.allowValueNdfHolidayFg != null) {
      this.baseEncoder.writeStartFid(27, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(27),
        false,
        encodable.allowValueNdfHolidayFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(27, streamout);
    }
    /*Object encoding*/
    if (encodable.allowGammaOrdersFg != null) {
      this.baseEncoder.writeStartFid(28, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(28),
        false,
        encodable.allowGammaOrdersFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(28, streamout);
    }
    /*Object encoding*/
    if (encodable.allowTrailingOrdersFg != null) {
      this.baseEncoder.writeStartFid(29, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(29),
        false,
        encodable.allowTrailingOrdersFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(29, streamout);
    }
    /*Object encoding*/
    if (encodable.allowInvertsFg != null) {
      this.baseEncoder.writeStartFid(30, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(30),
        false,
        encodable.allowInvertsFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(30, streamout);
    }
    /*Object encoding*/
    if (encodable.ndfHorizonCd != null) {
      this.baseEncoder.writeStartFid(31, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(31),
        false,
        encodable.ndfHorizonCd,
        streamout,
      );
      this.baseEncoder.writeEndFid(31, streamout);
    }
    /*Object encoding*/
    if (encodable.temperatureTypeId != null) {
      this.baseEncoder.writeStartFid(32, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(32),
        false,
        encodable.temperatureTypeId,
        streamout,
      );
      this.baseEncoder.writeEndFid(32, streamout);
    }
    /*Object encoding*/
    if (encodable.spotPrecision != null) {
      this.baseEncoder.writeStartFid(33, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(33),
        false,
        encodable.spotPrecision,
        streamout,
      );
      this.baseEncoder.writeEndFid(33, streamout);
    }
    /*Object encoding*/
    if (encodable.spotInvertPrecision != null) {
      this.baseEncoder.writeStartFid(34, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(34),
        false,
        encodable.spotInvertPrecision,
        streamout,
      );
      this.baseEncoder.writeEndFid(34, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerManTpSpreadType != null) {
      this.baseEncoder.writeStartFid(35, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(35),
        false,
        encodable.triggerManTpSpreadType,
        streamout,
      );
      this.baseEncoder.writeEndFid(35, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerManSlSpreadType != null) {
      this.baseEncoder.writeStartFid(36, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(36),
        false,
        encodable.triggerManSlSpreadType,
        streamout,
      );
      this.baseEncoder.writeEndFid(36, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerManCallSpreadType != null) {
      this.baseEncoder.writeStartFid(37, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(37),
        false,
        encodable.triggerManCallSpreadType,
        streamout,
      );
      this.baseEncoder.writeEndFid(37, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerAutoTpSpreadType != null) {
      this.baseEncoder.writeStartFid(38, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(38),
        false,
        encodable.triggerAutoTpSpreadType,
        streamout,
      );
      this.baseEncoder.writeEndFid(38, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerAutoSlSpreadType != null) {
      this.baseEncoder.writeStartFid(39, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(39),
        false,
        encodable.triggerAutoSlSpreadType,
        streamout,
      );
      this.baseEncoder.writeEndFid(39, streamout);
    }
    /*Object encoding*/
    if (encodable.triggerAutoCallSpreadType != null) {
      this.baseEncoder.writeStartFid(40, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(40),
        false,
        encodable.triggerAutoCallSpreadType,
        streamout,
      );
      this.baseEncoder.writeEndFid(40, streamout);
    }
    /*Object encoding*/
    if (encodable.limitEntrySpotDecimals != null) {
      this.baseEncoder.writeStartFid(41, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(41),
        false,
        encodable.limitEntrySpotDecimals,
        streamout,
      );
      this.baseEncoder.writeEndFid(41, streamout);
    }
    /*Object encoding*/
    if (encodable.limitEntrySpotInvertDecimals != null) {
      this.baseEncoder.writeStartFid(42, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(42),
        false,
        encodable.limitEntrySpotInvertDecimals,
        streamout,
      );
      this.baseEncoder.writeEndFid(42, streamout);
    }
    /*Object encoding*/
    if (encodable.tPFillTolerance != null) {
      this.baseEncoder.writeStartFid(43, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(43),
        false,
        encodable.tPFillTolerance,
        streamout,
      );
      this.baseEncoder.writeEndFid(43, streamout);
    }
    /*Object encoding*/
    if (encodable.tPFillToleranceUnits != null) {
      this.baseEncoder.writeStartFid(44, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(44),
        false,
        encodable.tPFillToleranceUnits,
        streamout,
      );
      this.baseEncoder.writeEndFid(44, streamout);
    }
    /*Object encoding*/
    if (encodable.sLFillTolerance != null) {
      this.baseEncoder.writeStartFid(45, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(45),
        false,
        encodable.sLFillTolerance,
        streamout,
      );
      this.baseEncoder.writeEndFid(45, streamout);
    }
    /*Object encoding*/
    if (encodable.sLFillToleranceUnits != null) {
      this.baseEncoder.writeStartFid(46, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(46),
        false,
        encodable.sLFillToleranceUnits,
        streamout,
      );
      this.baseEncoder.writeEndFid(46, streamout);
    }
    /*Object encoding*/
    if (encodable.entryRateTolerance != null) {
      this.baseEncoder.writeStartFid(47, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(47),
        false,
        encodable.entryRateTolerance,
        streamout,
      );
      this.baseEncoder.writeEndFid(47, streamout);
    }
    /*Object encoding*/
    if (encodable.entryRateToleranceUnits != null) {
      this.baseEncoder.writeStartFid(48, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(48),
        false,
        encodable.entryRateToleranceUnits,
        streamout,
      );
      this.baseEncoder.writeEndFid(48, streamout);
    }
    /*Object encoding*/
    if (encodable.fillRateTolerance != null) {
      this.baseEncoder.writeStartFid(49, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(49),
        false,
        encodable.fillRateTolerance,
        streamout,
      );
      this.baseEncoder.writeEndFid(49, streamout);
    }
    /*Object encoding*/
    if (encodable.fillRateToleranceUnits != null) {
      this.baseEncoder.writeStartFid(50, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(50),
        false,
        encodable.fillRateToleranceUnits,
        streamout,
      );
      this.baseEncoder.writeEndFid(50, streamout);
    }
    /*Object encoding*/
    if (encodable.failWrongSideOfMktFg != null) {
      this.baseEncoder.writeStartFid(51, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(51),
        false,
        encodable.failWrongSideOfMktFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(51, streamout);
    }
    /*Object encoding*/
    if (encodable.markupSptDecimals != null) {
      this.baseEncoder.writeStartFid(52, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(52),
        false,
        encodable.markupSptDecimals,
        streamout,
      );
      this.baseEncoder.writeEndFid(52, streamout);
    }
    /*Object encoding*/
    if (encodable.markupSptInvDecimals != null) {
      this.baseEncoder.writeStartFid(53, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(53),
        false,
        encodable.markupSptInvDecimals,
        streamout,
      );
      this.baseEncoder.writeEndFid(53, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdPipsQty != null) {
      this.baseEncoder.writeStartFid(54, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(54),
        false,
        encodable.fwdPipsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(54, streamout);
    }
    /*Object encoding*/
    if (encodable.fwdInvertPipsQty != null) {
      this.baseEncoder.writeStartFid(55, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(55),
        false,
        encodable.fwdInvertPipsQty,
        streamout,
      );
      this.baseEncoder.writeEndFid(55, streamout);
    }
    /*Object encoding*/
    if (encodable.allowBmarkSpotOrdersFg != null) {
      this.baseEncoder.writeStartFid(56, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(56),
        false,
        encodable.allowBmarkSpotOrdersFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(56, streamout);
    }
    /*Object encoding*/
    if (encodable.allowBmarkFwdOrdersFg != null) {
      this.baseEncoder.writeStartFid(57, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(57),
        false,
        encodable.allowBmarkFwdOrdersFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(57, streamout);
    }
    /*Object encoding*/
    if (encodable.intArbLiquidReplenishAmt != null) {
      this.baseEncoder.writeStartFid(58, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(58),
        false,
        encodable.intArbLiquidReplenishAmt,
        streamout,
      );
      this.baseEncoder.writeEndFid(58, streamout);
    }
    /*Object encoding*/
    if (encodable.allowAlgoOrders != null) {
      this.baseEncoder.writeStartFid(59, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(59),
        false,
        encodable.allowAlgoOrders,
        streamout,
      );
      this.baseEncoder.writeEndFid(59, streamout);
    }
    /*Object encoding*/
    if (encodable.allowInvertAlgoOrders != null) {
      this.baseEncoder.writeStartFid(60, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(60),
        false,
        encodable.allowInvertAlgoOrders,
        streamout,
      );
      this.baseEncoder.writeEndFid(60, streamout);
    }
    /*Object encoding*/
    if (encodable.additionalMidRoundingPrecision != null) {
      this.baseEncoder.writeStartFid(61, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(61),
        false,
        encodable.additionalMidRoundingPrecision,
        streamout,
      );
      this.baseEncoder.writeEndFid(61, streamout);
    }
    /*Object encoding*/
    if (encodable.bmSpotPrecision != null) {
      this.baseEncoder.writeStartFid(62, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(62),
        false,
        encodable.bmSpotPrecision,
        streamout,
      );
      this.baseEncoder.writeEndFid(62, streamout);
    }
    /*Object encoding*/
    if (encodable.bmSpotInvPrecision != null) {
      this.baseEncoder.writeStartFid(63, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(63),
        false,
        encodable.bmSpotInvPrecision,
        streamout,
      );
      this.baseEncoder.writeEndFid(63, streamout);
    }
    /*Object encoding*/
    if (encodable.allowMarketOrdersFg != null) {
      this.baseEncoder.writeStartFid(64, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(64),
        false,
        encodable.allowMarketOrdersFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(64, streamout);
    }
    /*Object encoding*/
    if (encodable.allowAlgoFwdOrders != null) {
      this.baseEncoder.writeStartFid(65, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(65),
        false,
        encodable.allowAlgoFwdOrders,
        streamout,
      );
      this.baseEncoder.writeEndFid(65, streamout);
    }
    /*Object encoding*/
    if (encodable.slSlippagePips != null) {
      this.baseEncoder.writeStartFid(66, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(66),
        false,
        encodable.slSlippagePips,
        streamout,
      );
      this.baseEncoder.writeEndFid(66, streamout);
    }
    /*Object encoding*/
    if (encodable.minimumGammaDeltaPips != null) {
      this.baseEncoder.writeStartFid(67, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(67),
        false,
        encodable.minimumGammaDeltaPips,
        streamout,
      );
      this.baseEncoder.writeEndFid(67, streamout);
    }
    /*Object encoding*/
    if (encodable.entryAmtTolerance != null) {
      this.baseEncoder.writeStartFid(68, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(68),
        false,
        encodable.entryAmtTolerance,
        streamout,
      );
      this.baseEncoder.writeEndFid(68, streamout);
    }
    /*Object encoding*/
    if (encodable.trailingStopMinPips != null) {
      this.baseEncoder.writeStartFid(69, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(69),
        false,
        encodable.trailingStopMinPips,
        streamout,
      );
      this.baseEncoder.writeEndFid(69, streamout);
    }
    /*Object encoding*/
    if (encodable.trailingStopMinInvPips != null) {
      this.baseEncoder.writeStartFid(70, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(70),
        false,
        encodable.trailingStopMinInvPips,
        streamout,
      );
      this.baseEncoder.writeEndFid(70, streamout);
    }
    /*Object encoding*/
    if (encodable.allowNdfAlgoOrders != null) {
      this.baseEncoder.writeStartFid(71, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(71),
        false,
        encodable.allowNdfAlgoOrders,
        streamout,
      );
      this.baseEncoder.writeEndFid(71, streamout);
    }
    /*Object encoding*/
    if (encodable.adjustmentCalculationAutoThreshold != null) {
      this.baseEncoder.writeStartFid(72, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(72),
        false,
        encodable.adjustmentCalculationAutoThreshold,
        streamout,
      );
      this.baseEncoder.writeEndFid(72, streamout);
    }
    /*Object encoding*/
    if (encodable.adjustmentCalculationManualThreshold != null) {
      this.baseEncoder.writeStartFid(73, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(73),
        false,
        encodable.adjustmentCalculationManualThreshold,
        streamout,
      );
      this.baseEncoder.writeEndFid(73, streamout);
    }
    /*Object encoding*/
    if (encodable.failWrongSideOfMktFutureFg != null) {
      this.baseEncoder.writeStartFid(74, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(74),
        false,
        encodable.failWrongSideOfMktFutureFg,
        streamout,
      );
      this.baseEncoder.writeEndFid(74, streamout);
    }
    /*Object encoding*/
    if (encodable.termBaseEntry != null) {
      this.baseEncoder.writeStartFid(75, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(75),
        false,
        encodable.termBaseEntry,
        streamout,
      );
      this.baseEncoder.writeEndFid(75, streamout);
    }
    /*Object encoding*/
    if (encodable.messageId != null) {
      this.baseEncoder.writeStartFid(100, streamout);
      this.baseEncoder.writeObject(
        false,
        CurrencyPairImplEncoder.fidTypeMap.get(100),
        false,
        encodable.messageId,
        streamout,
      );
      this.baseEncoder.writeEndFid(100, streamout);
    }
    /*Object encoding*/
    if(encodable.sessionOnly!=null){
        this.baseEncoder.writeStartFid(10010,streamout);
        this.baseEncoder.writeObject(false,CurrencyPairImplEncoder.fidTypeMap.get(10010),false,encodable.sessionOnly,streamout);
        this.baseEncoder.writeEndFid(10010,streamout);
    }
    this.baseEncoder.writeEndEncoding(streamout);
  }

  static fidTypeMap: Map<number, string> = new Map<number, string>([
    [1, "java.lang.String"],
    [3, "java.lang.Boolean"],
    [4, "java.lang.Integer"],
    [6, "java.lang.Integer"],
    [7, "java.lang.String"],
    [8, "java.lang.Double"],
    [9, "java.lang.Double"],
    [10, "java.lang.Integer"],
    [11, "java.lang.Long"],
    [12, "java.lang.Boolean"],
    [13, "java.lang.Integer"],
    [15, "java.lang.Long"],
    [16, "java.lang.Boolean"],
    [17, "java.lang.Integer"],
    [18, "java.lang.Integer"],
    [19, "java.lang.Long"],
    [20, "java.lang.Boolean"],
    [21, "java.lang.Boolean"],
    [22, "java.lang.Boolean"],
    [25, "java.lang.Boolean"],
    [26, "java.lang.Boolean"],
    [27, "java.lang.Boolean"],
    [28, "java.lang.Boolean"],
    [29, "java.lang.Boolean"],
    [30, "java.lang.Boolean"],
    [31, "com.bcdfx.model.NdfHorizon"],
    [32, "com.bcdfx.model.UnitType"],
    [33, "com.bcdfx.model.Precision"],
    [34, "com.bcdfx.model.Precision"],
    [35, "com.bcdfx.model.TriggerLogicType"],
    [36, "com.bcdfx.model.TriggerLogicType"],
    [37, "com.bcdfx.model.TriggerLogicType"],
    [38, "com.bcdfx.model.TriggerLogicType"],
    [39, "com.bcdfx.model.TriggerLogicType"],
    [40, "com.bcdfx.model.TriggerLogicType"],
    [41, "java.lang.Integer"],
    [42, "java.lang.Integer"],
    [43, "java.math.BigDecimal"],
    [44, "com.bcdfx.model.UnitType"],
    [45, "java.math.BigDecimal"],
    [46, "com.bcdfx.model.UnitType"],
    [47, "java.math.BigDecimal"],
    [48, "com.bcdfx.model.UnitType"],
    [49, "java.math.BigDecimal"],
    [50, "com.bcdfx.model.UnitType"],
    [51, "java.lang.Boolean"],
    [52, "java.lang.Integer"],
    [53, "java.lang.Integer"],
    [54, "java.lang.Integer"],
    [55, "java.lang.Integer"],
    [56, "java.lang.Boolean"],
    [57, "java.lang.Boolean"],
    [58, "java.lang.Integer"],
    [59, "java.lang.Boolean"],
    [60, "java.lang.Boolean"],
    [61, "java.lang.Integer"],
    [62, "java.lang.Integer"],
    [63, "java.lang.Integer"],
    [64, "java.lang.Boolean"],
    [65, "java.lang.Boolean"],
    [66, "java.math.BigDecimal"],
    [67, "java.lang.Long"],
    [68, "java.math.BigDecimal"],
    [69, "java.lang.Long"],
    [70, "java.lang.Long"],
    [71, "java.lang.Boolean"],
    [72, "java.math.BigDecimal"],
    [73, "java.math.BigDecimal"],
    [74, "java.lang.Boolean"],
    [75, "com.bcdfx.model.common.api.enums.TermBaseEntry"],
    [100, "java.lang.String"],
    [10010, "java.lang.String"],
  ]);

  /**
   * Constructs the event from a given byte stream
   */
  public decode(encodable: CurrencyPairImpl, streamin: CubiqTS.ByteBuffer): void {
    this.baseEncoder.decode(encodable, streamin);

    while (true) {
      let ct: string = this.baseEncoder.readCtrl(streamin);
      if (ct == "^F") {
        break;
      }
      if (ct == "^H") continue;
      let fid: number = this.baseEncoder.parseCtrlAsFid(ct);
      if (this.supportsFid(fid) == false) this.baseEncoder.seekToNextFid(fid, streamin);
      switch (fid) {
        case 1: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(1),
            streamin,
          );
          encodable.base = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 3: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(3),
            streamin,
          );
          encodable.fwdEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 4: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(4),
            streamin,
          );
          encodable.fwdInvertDecimalsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 6: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(6),
            streamin,
          );
          encodable.fwdRateDecimalsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 7: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(7),
            streamin,
          );
          encodable.nonBase = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 8: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(8),
            streamin,
          );
          encodable.orderTempHotValue = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 9: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(9),
            streamin,
          );
          encodable.orderTempWarmValue = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(10),
            streamin,
          );
          encodable.pipsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 11: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(11),
            streamin,
          );
          encodable.rateStaleTimeInSecs = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 12: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(12),
            streamin,
          );
          encodable.spotEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 13: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(13),
            streamin,
          );
          encodable.spotInvertDecimalsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 15: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(15),
            streamin,
          );
          encodable.stamp = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 16: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(16),
            streamin,
          );
          encodable.ndfEnabledFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 17: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(17),
            streamin,
          );
          encodable.rateDecimalsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 18: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(18),
            streamin,
          );
          encodable.spotDaysQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 19: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(19),
            streamin,
          );
          encodable.fixingDaysQty = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 20: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(20),
            streamin,
          );
          encodable.allowSpotFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 21: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(21),
            streamin,
          );
          encodable.allowFwdSpotTriggerFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 22: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(22),
            streamin,
          );
          encodable.allowFwdFwdTriggerFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 25: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(25),
            streamin,
          );
          encodable.allowNdfSpotTriggerFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 26: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(26),
            streamin,
          );
          encodable.allowNdfFwdTriggerFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 27: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(27),
            streamin,
          );
          encodable.allowValueNdfHolidayFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 28: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(28),
            streamin,
          );
          encodable.allowGammaOrdersFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 29: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(29),
            streamin,
          );
          encodable.allowTrailingOrdersFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 30: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(30),
            streamin,
          );
          encodable.allowInvertsFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 31: {
          /*Object encoding*/
          let val: CubiqTS.NdfHorizon = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(31),
            streamin,
          );
          encodable.ndfHorizonCd = <CubiqTS.NdfHorizon>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 32: {
          /*Object encoding*/
          let val: CubiqTS.UnitType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(32),
            streamin,
          );
          encodable.temperatureTypeId = <CubiqTS.UnitType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 33: {
          /*Object encoding*/
          let val: CubiqTS.Precision = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(33),
            streamin,
          );
          encodable.spotPrecision = <CubiqTS.Precision>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 34: {
          /*Object encoding*/
          let val: CubiqTS.Precision = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(34),
            streamin,
          );
          encodable.spotInvertPrecision = <CubiqTS.Precision>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 35: {
          /*Object encoding*/
          let val: CubiqTS.TriggerLogicType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(35),
            streamin,
          );
          encodable.triggerManTpSpreadType = <CubiqTS.TriggerLogicType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 36: {
          /*Object encoding*/
          let val: CubiqTS.TriggerLogicType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(36),
            streamin,
          );
          encodable.triggerManSlSpreadType = <CubiqTS.TriggerLogicType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 37: {
          /*Object encoding*/
          let val: CubiqTS.TriggerLogicType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(37),
            streamin,
          );
          encodable.triggerManCallSpreadType = <CubiqTS.TriggerLogicType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 38: {
          /*Object encoding*/
          let val: CubiqTS.TriggerLogicType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(38),
            streamin,
          );
          encodable.triggerAutoTpSpreadType = <CubiqTS.TriggerLogicType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 39: {
          /*Object encoding*/
          let val: CubiqTS.TriggerLogicType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(39),
            streamin,
          );
          encodable.triggerAutoSlSpreadType = <CubiqTS.TriggerLogicType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 40: {
          /*Object encoding*/
          let val: CubiqTS.TriggerLogicType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(40),
            streamin,
          );
          encodable.triggerAutoCallSpreadType = <CubiqTS.TriggerLogicType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 41: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(41),
            streamin,
          );
          encodable.limitEntrySpotDecimals = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 42: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(42),
            streamin,
          );
          encodable.limitEntrySpotInvertDecimals = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 43: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(43),
            streamin,
          );
          encodable.tPFillTolerance = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 44: {
          /*Object encoding*/
          let val: CubiqTS.UnitType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(44),
            streamin,
          );
          encodable.tPFillToleranceUnits = <CubiqTS.UnitType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 45: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(45),
            streamin,
          );
          encodable.sLFillTolerance = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 46: {
          /*Object encoding*/
          let val: CubiqTS.UnitType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(46),
            streamin,
          );
          encodable.sLFillToleranceUnits = <CubiqTS.UnitType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 47: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(47),
            streamin,
          );
          encodable.entryRateTolerance = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 48: {
          /*Object encoding*/
          let val: CubiqTS.UnitType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(48),
            streamin,
          );
          encodable.entryRateToleranceUnits = <CubiqTS.UnitType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 49: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(49),
            streamin,
          );
          encodable.fillRateTolerance = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 50: {
          /*Object encoding*/
          let val: CubiqTS.UnitType = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(50),
            streamin,
          );
          encodable.fillRateToleranceUnits = <CubiqTS.UnitType>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 51: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(51),
            streamin,
          );
          encodable.failWrongSideOfMktFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 52: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(52),
            streamin,
          );
          encodable.markupSptDecimals = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 53: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(53),
            streamin,
          );
          encodable.markupSptInvDecimals = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 54: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(54),
            streamin,
          );
          encodable.fwdPipsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 55: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(55),
            streamin,
          );
          encodable.fwdInvertPipsQty = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 56: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(56),
            streamin,
          );
          encodable.allowBmarkSpotOrdersFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 57: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(57),
            streamin,
          );
          encodable.allowBmarkFwdOrdersFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 58: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(58),
            streamin,
          );
          encodable.intArbLiquidReplenishAmt = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 59: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(59),
            streamin,
          );
          encodable.allowAlgoOrders = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 60: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(60),
            streamin,
          );
          encodable.allowInvertAlgoOrders = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 61: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(61),
            streamin,
          );
          encodable.additionalMidRoundingPrecision = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 62: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(62),
            streamin,
          );
          encodable.bmSpotPrecision = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 63: {
          /*Object encoding*/
          let val: number = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(63),
            streamin,
          );
          encodable.bmSpotInvPrecision = <number>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 64: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(64),
            streamin,
          );
          encodable.allowMarketOrdersFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 65: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(65),
            streamin,
          );
          encodable.allowAlgoFwdOrders = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 66: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(66),
            streamin,
          );
          encodable.slSlippagePips = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 67: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(67),
            streamin,
          );
          encodable.minimumGammaDeltaPips = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 68: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(68),
            streamin,
          );
          encodable.entryAmtTolerance = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 69: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(69),
            streamin,
          );
          encodable.trailingStopMinPips = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 70: {
          /*Object encoding*/
          let val: CubiqTS.Long = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(70),
            streamin,
          );
          encodable.trailingStopMinInvPips = <CubiqTS.Long>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 71: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(71),
            streamin,
          );
          encodable.allowNdfAlgoOrders = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 72: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(72),
            streamin,
          );
          encodable.adjustmentCalculationAutoThreshold = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 73: {
          /*Object encoding*/
          let val: CubiqTS.BigNumber = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(73),
            streamin,
          );
          encodable.adjustmentCalculationManualThreshold = <CubiqTS.BigNumber>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 74: {
          /*Object encoding*/
          let val: boolean = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(74),
            streamin,
          );
          encodable.failWrongSideOfMktFutureFg = <boolean>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 75: {
          /*Object encoding*/
          let val: CubiqTS.TermBaseEntry = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(75),
            streamin,
          );
          encodable.termBaseEntry = <CubiqTS.TermBaseEntry>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 100: {
          /*Object encoding*/
          let val: string = this.baseEncoder.readObject(
            false,
            false,
            CurrencyPairImplEncoder.fidTypeMap.get(100),
            streamin,
          );
          encodable.messageId = <string>val;
          this.baseEncoder.readEndFid(streamin);
          break;
        }
        case 10010:
        {
            /*Object encoding*/
            let val_10010:string=this.baseEncoder.readObject(false,false,CurrencyPairImplEncoder.fidTypeMap.get(10010),streamin);
            encodable.sessionOnly=val_10010;
            this.baseEncoder.readEndFid(streamin);
            break;
        }
      }
    }
  }

  private supportsFid(fid: number): boolean {
    return CurrencyPairImplEncoder.fidTypeMap.has(fid);
  }
}
